/* eslint-disable react/jsx-no-useless-fragment */
export const Domain = () => <>{ window.location.host }</>;